import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";
import { BonusRow } from "./BonusRow";

const HEADS = ["index", "serial", "employee", "amount", "reason", "source", "status", "received",
  "created", "actions"];

// جدول المكافآت (قابل للتمرير أفقياً على الجوال).
export const BonusTable = ({ rows, ...handlers }) => {
  const { t } = useTranslation();
  if (!rows.length) {
    return (
      <NeuCard className="p-6 text-center text-sm text-muted-foreground" data-testid="bonus-empty">
        {t("bonus.empty")}
      </NeuCard>
    );
  }
  return (
    <NeuCard className="overflow-x-auto p-3" data-testid="bonus-table">
      <table className="w-full min-w-[980px] text-start">
        <thead>
          <tr className="border-b border-border/60">
            {HEADS.map((head) => (
              <th key={head} className="p-2 text-start text-[11px] font-black text-muted-foreground">
                {t(`bonus.table.${head}`)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <BonusRow key={row.bonus_id} row={row} index={index} {...handlers} />
          ))}
        </tbody>
      </table>
    </NeuCard>
  );
};
